/* =================== VOLTAR AO TOPO =================== */
$(function () {
  function toggleGoTop() {
    var scrollTop = $(window).scrollTop();
    if (scrollTop > 100) {
      $(".gotop").addClass("active");
    } else {
      $(".gotop").removeClass("active");
    }
  }
  toggleGoTop();
  $(window).on(
    "scroll",
    debounce(function () {
      toggleGoTop();
    }, 100)
  );
  $(".gotop").on("click", function () {
    scrollToX("html");
  });

  // Cursor
  $(function () {
    var cursor = document.querySelector("#cursor"),
      cursorBorder = document.querySelector("#cursor-border"),
      currentPos = { x: 0, y: 0 },
      targetPos = { x: 0, y: 0 };

    document.addEventListener("mousemove", function (e) {
      currentPos.x = e.clientX;
      currentPos.y = e.clientY;
      cursor.style.transform =
        "translate(" + e.clientX + "px, " + e.clientY + "px)";
    });

    requestAnimationFrame(function updateCursor() {
      targetPos.x += (currentPos.x - targetPos.x) / 8;
      targetPos.y += (currentPos.y - targetPos.y) / 8;
      cursorBorder.style.transform =
        "translate(" + targetPos.x + "px, " + targetPos.y + "px)";
      requestAnimationFrame(updateCursor);
    });

    // Adiciona event listeners para os links
    var links = document.querySelectorAll("a");
    links.forEach(function (link) {
      link.addEventListener("mouseenter", function () {
        cursorBorder.classList.add("hovered");
      });

      link.addEventListener("mouseleave", function () {
        cursorBorder.classList.remove("hovered");
      });
    });
  });
});
